import React, { FC } from 'react'
import { CheckIcon } from './Icon'
import { Wrapper } from './styled'

interface ComponentProps {
	text?: () => JSX.Element
}

export const CheckWithElement: FC<ComponentProps> = ({ text }) => (
	<Wrapper>
		<CheckIcon />
		{text()}
	</Wrapper>
)
